export const configureNewRelic = () => {
	return `
  ;window.NREUM||(NREUM={})
  ;NREUM.init=${import.meta.env.VITE_NR_INIT};
  ;NREUM.loader_config=${import.meta.env.VITE_NR_LOADER_CONFIG};
  ;NREUM.info=${import.meta.env.VITE_NR_INFO_CONFIG};
  `;
};
